var $dc3c17602f1b7464$exports = {};
$dc3c17602f1b7464$exports = {
    "valid": `Veljavno`
};


export {$dc3c17602f1b7464$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
